import { styled } from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

export const HeaderContainer = styled(Flex)`
    height: 64px;
    padding: 8px 24px 8px 16px;
    border-bottom: 1px solid ${colorsPalettes.carbon[100]};
    box-sizing: content-box;
`;

export const Divider = styled.span`
    width: 1px;
    height: 100%;
    background: ${colorsPalettes.carbon[100]};
`;

export const LoaderWrapper = styled(Flex)`
    width: 100%;
    align-items: center;
    margin-left: 24px;

    svg {
        border-radius: 8px;
    }
`;
